// Live US phone formatting as the user types: 4805551234 → (480) 555-1234.
// Strips non-digits, caps at 10, builds the (###) ###-#### shape progressively so
// digits never just stack. Pair with the placeholder PHONE_MASK below.
export function formatPhone(value: string): string {
  const d = value.replace(/\D/g, '').slice(0, 10);
  const a = d.slice(0, 3);
  const b = d.slice(3, 6);
  const c = d.slice(6, 10);
  if (d.length > 6) return `(${a}) ${b}-${c}`;
  if (d.length > 3) return `(${a}) ${b}`;
  if (d.length > 0) return `(${a}`;
  return '';
}

// Placeholder mask shown in empty phone inputs so the expected shape is obvious.
export const PHONE_MASK = '(###) ###-####';

// ───────── Booking date/time helpers ─────────
// Shared by the booking form and the reschedule modal so both round and format
// times identically. Bookings are made in 30-minute blocks, never by the minute.
function pad(n: number) {
  return n < 10 ? `0${n}` : `${n}`;
}

export function roundToHalfHour(d: Date): Date {
  const r = new Date(d);
  r.setSeconds(0, 0);
  r.setMinutes(r.getMinutes() < 30 ? 0 : 30);
  return r;
}

// Local (not UTC) value for an <input type="datetime-local">.
export function localDateTime(d: Date): string {
  const h = roundToHalfHour(d);
  return `${h.getFullYear()}-${pad(h.getMonth() + 1)}-${pad(h.getDate())}T${pad(
    h.getHours()
  )}:${pad(h.getMinutes())}`;
}

// Local value for an <input type="date">.
export function localDatePart(d: Date): string {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

// Local value for an <input type="time">, snapped to the half hour.
export function localTimePart(d: Date): string {
  const h = roundToHalfHour(d);
  return `${pad(h.getHours())}:${pad(h.getMinutes())}`;
}

// Combine an <input type="date"> value and an <input type="time"> value into a
// local Date. Returns null if either half is missing or unparseable.
export function fromDateAndTime(date: string, time: string): Date | null {
  if (!date || !time) return null;
  const d = new Date(`${date}T${time}`);
  return isNaN(d.getTime()) ? null : d;
}
